import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingAgentReviewScreen } from './pricing-agent-review-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';
import { validate } from 'uuid';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.PricingAgentReview
>;

export const PricingAgentReviewScreenWrapper: React.FC<Props> = ({ route }) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const { lastCompletedAt, taskName, taskTypeUUID } = route.params;
  const isTaskTypeUUIDValid = validate(taskTypeUUID);

  const {
    loading: accessLoading,
    error: accessError,
    hasPricingAgentAccess,
  } = useBusinessOrganizationPricingConfig();

  const accessDenied = !accessLoading && !accessError && !hasPricingAgentAccess;

  useEffect(() => {
    if (!isTaskTypeUUIDValid || accessDenied) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [accessDenied, isTaskTypeUUIDValid, navigation]);

  if (!isTaskTypeUUIDValid || accessDenied) {
    return null;
  }

  return accessLoading ? (
    <LogoLoadingIndicator />
  ) : (
    <PricingAgentReviewScreen
      lastCompletedAt={lastCompletedAt}
      taskName={taskName}
      taskTypeUUID={taskTypeUUID}
    />
  );
};
